export default __webpack_public_path__ + "static/media/1(10).cf00c444.jpg";